import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../core/guards/auth.guard'
import { NotFoundComponent } from '../shared/components/not-found/not-found.component'
import { ContactanosComponent } from './contactanos/contactanos.component'
import { DashboardComponent } from './dashboard/dashboard.component'
import { HomeComponent } from './home/home.component'

const homeRoutes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'dian',
        loadChildren: () => import('../modules/dian/dian.module').then((m) => m.DianModule),
      },

      {
        path: 'configuracion',
        canActivate: [AuthGuard],
        loadChildren: () => import('../modules/configuracion/configuracion.module').then((m) => m.ConfiguracionModule),
      },
      {
        path: 'contactanos',
        component: ContactanosComponent,
        canActivate: [AuthGuard],
      },
      { path: 'unauthorized', component: NotFoundComponent /*UnauthorizedComponent*/ },
      //{ path: '**', component: NotFoundComponent }
    ],
    // canActivate: [AnonimoGuard]
  },
]

@NgModule({
  imports: [RouterModule.forChild(homeRoutes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
